import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconUserCard = props => (
  <SvgIcon {...props} viewBox="0 0 20 15.999999">
    <path d="m18-4.7684e-7h-16c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h16c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zm-8 2.75c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25-2.25-1.01-2.25-2.25 1.01-2.25 2.25-2.25zm5 10.25h-10v-1.5c0-1.67 3.33-2.5 5-2.5s5 0.83 5 2.5v1.5z" />
  </SvgIcon>
);

export default IconUserCard;



// WEBPACK FOOTER //
// ./src/components/icons/IconUserCard.js